import { Base } from '@studiometa/js-toolkit';
import { addClass, removeClass } from '@studiometa/js-toolkit/utils';

/**
 * Homepage class.
 */
export default class GlossaryNav extends Base {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'GlossaryNav',
    refs: ['nav[]'],
    log: true,
  };

  /**
   * Get nav by hash
   * @returns {object}
   */
  get $navByHash() {
    return Object.fromEntries(
      this.$refs.nav.map((navElement) => [navElement.href.split('#')[1], navElement]),
    );
  }

  /**
   * Mounted
   */
  mounted() {
    addClass(this.$navByHash[window.location.hash.slice(1)], 'is-active');
  }

  /**
   * Open child panel
   * @param {object} e
   * @param {HTMLElement} e.currentTarget
   */
  onNavClick({ currentTarget }) {
    this.$log(this.$navByHash);
    this.$refs.nav.forEach((element) => removeClass(element, 'is-active'));
    addClass(currentTarget, 'is-active');
  }
}
